export default __webpack_public_path__ + "static/media/IMG_2335 copie (2).9a03065b.jpg";